import { $, aviso, avisoHtml, el, esc, limpiar, num, pedir, pedirTodo, puede, rpc, rpcLee, sb, ordenarPor } from './nucleo';
import { irAEntregar } from './vueltas';
import { ofrecerPedirCorte, ofrecerVale } from './aprobaciones';
import { cargarStock } from './stock';
import { cargarPedidos } from './pedidos';
import { irACobros } from './cobros';

let CIRCUITO = [], TRANSICIONES = [];

//  LO ENTREGADO QUE VOLVIÓ (D183). El Circuito lista lo que no es final; lo
//  Entregado se trae de a UN pedido, a pedido, a una lista aparte. `BUSCADO` es
//  el código que se buscó (null: no hay búsqueda); `E_ENTREGADOS`, por qué no
//  se pudo leer. Se vacía al entrar de nuevo a la pestaña.
let ENTREGADOS = [], BUSCADO: string | null = null, E_ENTREGADOS = '';
//  El código que trae «Volvió algo» desde Pedidos: se busca cuando la pestaña
//  terminó de cargar (si se buscara antes, la carga de la pestaña lo borraría).
let POR_BUSCAR: string | null = null;
//  Y la carrera del buscador: una búsqueda vieja que contesta tarde no pisa la
//  nueva (ni una que contesta después de volver a entrar a la pestaña).
let TURNO_BUSQUEDA = 0;
//  El ítem se resuelve en las DOS listas: los lugares que buscan un ítem por id
//  (el click, que se lo pasa al panel; `mover` y `caducarVale`) pasan por acá.
const itemDe = (id: number) =>
  CIRCUITO.find(x => Number(x.id) === Number(id)) || ENTREGADOS.find(x => Number(x.id) === Number(id));
//  Quién ve el buscador: quien tiene algún paso que sale de Entregado (el
//  cajero, el cajero 2 y los que administran). Lo dice la base, no un rol.
export const buscaEntregados = () => TRANSICIONES.some(t => t.desde === 'entregado');

//  LO QUE NO SE PUDO LEER DE LA LISTA DE ÍTEMS. Sin esto, `cargarCircuito`
//  salía por su `return` dejando las filas de la lectura anterior pintadas
//  **como si fueran de ahora**, con botones vivos y contadores sobre una lista
//  que nadie leyó. Regla del 4/9: no un vacío leído como "no hay nada", sino un
//  dato VIEJO leído como "esto es lo que hay".
let ERROR_ITEMS = '';
//  Y EL ESTADO CERO (D103): antes de la primera respuesta una tabla vacía se
//  lee "no hay nada pendiente". Son TRES estados, no dos.
let LEIDO_ITEMS = false;
//  Y LA CARRERA. `cargarCircuito()` se llama desde `entrar()`, al volver a la
//  pestaña y al final de cada `mover()`, así que hay dos en viaje a la vez, y la
//  que FALLA es la que más tarda (D92): la respuesta vieja llegando después de
//  la nueva es el caso probable. Sin el turno, una lectura vieja que falló
//  vacía una tabla que la nueva pintó bien.
let TURNO_ITEMS = 0;

// ---------- circuito ----------
let FILTRO_ESTADO = '';

//  LO QUE NO SE PUDO LEER. Sin esto, una lectura caída dejaba `TRANSICIONES`
//  en cero y la pantalla contestaba «nada para vos» en TODAS las filas, con el
//  `<p class="hint">` de arriba explicando (mal) que ese paso no te corresponde.
let ERROR_TRANS = '';
//  Y LA LECTURA EN VIAJE (D103: tres estados, el tercero «todavía no llegó»).
//  Tapar sólo el error no alcanzaba: `entrar()` pedía los pasos y la tabla EN
//  PARALELO, y si la tabla llegaba primero, `pintarCircuito` corría con
//  `TRANSICIONES` en cero y `ERROR_TRANS` vacío: «nada para vos» sin cartel, y
//  nada repintaba después. Es el caso probable: `supabase-js` reintenta una
//  lectura caída ~7 segundos (D92) antes de contestar el fallo.
//
//  La promesa se guarda para que quien necesite la lista ESPERE la que ya
//  salió en vez de disparar otra.
let TRANS_EN_VUELO: Promise<void> | null = null;
//  Para quien pinta algo que depende de la lista y no puede esperarla antes
//  de pintar: Pedidos agrega «Volvió algo» cuando llega (166).
export const transicionesLeidas = () => TRANS_EN_VUELO;

export function cargarTransiciones(){
  TRANS_EN_VUELO = (async () => {
    const { data, error } = await pedir(sb.from('v_transiciones_posibles').select('*'));
    ERROR_TRANS = error ? error.message : '';
    TRANSICIONES = error ? [] : (data || []);
  })();
  return TRANS_EN_VUELO;
}

//  El reintento por destino (regla 11): las transiciones se leen UNA vez, en
//  `entrar()`; sin esto un corte de red dejaba el circuito sin botones hasta
//  Ctrl+F5. Primero ESPERA la lectura en viaje (si se mira `ERROR_TRANS` antes
//  de que conteste, está vacío y no se reintenta) y después decide. Si no
//  falló nada, no consulta nada (como `reintentarRecepcion`).
export async function reintentarTransiciones(){
  if (TRANS_EN_VUELO) await TRANS_EN_VUELO;
  if (ERROR_TRANS) await cargarTransiciones();
}

//  El cartel de las transiciones, en su propia función porque hay que pintarlo
//  en los DOS caminos de `cargarCircuito` (con la tabla caída se sale por el
//  `return` y quedaría un cartel viejo). El `else limpiar` va en TODOS.
function avisarTransiciones(){
  if (ERROR_TRANS)
    avisoHtml('#circTransMsg','bad',
      `No pude leer qué se puede hacer con cada ítem (${esc(ERROR_TRANS)}). ` +
      '<b>No quiere decir que no puedas hacer nada</b>, y mientras tanto lo de ' +
      'arriba no vale: los botones no están porque falta la lista, no porque el ' +
      'paso no te corresponda. Cambiá de pestaña y volvé, o recargá con Ctrl+F5.');
  else limpiar('#circTransMsg');
}

//  El cartel de la LISTA, en su propio div y no en `#circMsg`: ése es el del
//  resultado de cada acción y `mover()` arranca borrándolo, lo que borraría el
//  aviso de que las filas no se leyeron.
function avisarLista(){
  if (ERROR_ITEMS)
    avisoHtml('#circListaMsg','bad',
      `No pude leer qué hay para hacer (${esc(ERROR_ITEMS)}). ` +
      '<b>No quiere decir que no haya nada</b>: la tabla se vació a propósito, ' +
      'porque dejarte la de antes sería mostrarte lo viejo como si fuera lo de ' +
      'ahora. Cambiá de pestaña y volvé, o recargá con Ctrl+F5.');
  else limpiar('#circListaMsg');
}

//  EL ESTADO CERO, en su propia función porque hay que pintarlo ANTES de que
//  esta pantalla pida nada: `arranque.ts` pide primero las TRANSICIONES y sólo
//  después, encadenada, la lista, y en esa ventana (hasta ~7 segundos, D92) el
//  `<tbody>` quedaba vacío. Tapar el estado cero adentro de `cargarCircuito`
//  cubría sólo la segunda mitad de la espera.
export function esperandoCircuito(){
  if (!LEIDO_ITEMS && !ERROR_ITEMS) pintarCircuito();
}

export async function cargarCircuito(conservarBusqueda = false){
  //  Lo que no depende de la lectura va ANTES del `await`.
  const turno = ++TURNO_ITEMS;
  //  Entrar de nuevo a la pestaña olvida la búsqueda de Entregados; después de
  //  mover un ítem se conserva (y se vuelve a leer, en `mover`).
  if (!conservarBusqueda){
    ENTREGADOS = []; BUSCADO = null; E_ENTREGADOS = ''; TURNO_BUSQUEDA++;
    limpiar('#circBuscarMsg'); $('#circBuscar').value = '';
  }
  //  Lo que trajo «Volvió algo» se toma YA: si la lectura falla, no queda
  //  guardado para dispararse en otra entrada a la pestaña.
  const porBuscar = POR_BUSCAR; POR_BUSCAR = null;
  $('#circBuscarFila').classList.toggle('oculto', !buscaEntregados());
  esperandoCircuito();
  //  ENTEROS (pendiente 38): lo que está en viaje no puede ser «los primeros
  //  mil»; el servidor corta sin avisar (D122) y un ítem que no llegó nadie lo
  //  mueve. El orden se cierra con `id` para que las páginas no se pisen.
  const { data, error } = await pedirTodo(() => sb.from('v_items_pedido').select('*')
    .eq('es_final', false), { por: 'id', orden: ordenarPor('ocurrido_en', 'id') });
  //  LA RESPUESTA VIEJA NO PISA A LA NUEVA: si salió otra mientras ésta
  //  viajaba, acá no se toca nada, ni el cartel de los pasos.
  if (turno !== TURNO_ITEMS) return;
  avisarTransiciones();
  ERROR_ITEMS = error ? error.message : '';
  if (error){
    //  Se VACÍA: las filas de antes no son las de ahora ni sus contadores.
    //  Ojo: `CIRCUITO = []` parece redundante (con `ERROR_ITEMS`,
    //  `pintarCircuito` sale por su primera guarda) pero se deja para no
    //  conservar una lista vieja viva. Lo que sí se verifica es el `innerHTML`
    //  de los chips, que se pinta por su cuenta.
    CIRCUITO = [];
    $('#filtroEstados').innerHTML = '';
    avisarLista();
    pintarCircuito();
    return;
  }
  LEIDO_ITEMS = true;
  CIRCUITO = data || [];
  avisarLista();
  const estados = [...new Set(CIRCUITO.map(i => i.estado_nombre))];
  //  EL CHIP DEL FILTRO ELEGIDO NO SE EVAPORA: si el estado filtrado ya no
  //  está en la lista nueva, no quedaba NINGÚN radio tildado y la tabla decía
  //  «No hay nada pendiente» junto a un chip que contaba cuatro. Se deja el
  //  chip con su cero.
  if (FILTRO_ESTADO && !estados.includes(FILTRO_ESTADO)) estados.push(FILTRO_ESTADO);
  $('#filtroEstados').innerHTML =
    `<label><input type="radio" name="fe" value=""${!FILTRO_ESTADO?' checked':''}> Todo (${CIRCUITO.length})</label>` +
    estados.map(e => {
      const n = CIRCUITO.filter(i => i.estado_nombre === e).length;
      return `<label><input type="radio" name="fe" value="${esc(e)}"${
        FILTRO_ESTADO===e?' checked':''}> ${esc(e)} (${n})</label>`;
    }).join('');
  pintarCircuito();
  caducarVale();
  if (porBuscar && buscaEntregados()){
    $('#circBuscar').value = porBuscar;
    await buscarEntregados(porBuscar);
  }
}

//  «P-901», «901» o «p-00901» son el mismo pedido: los códigos son de cinco
//  cifras con ceros adelante, y desde el 100.000 enteros (D177).
const normalizarCodigo = (t: string) => {
  const n = t.trim().toUpperCase().replace(/^P-?/, '');
  return /^\d+$/.test(n) ? 'P-' + n.padStart(5, '0') : t.trim().toUpperCase();
};

async function buscarEntregados(texto: string){
  limpiar('#circBuscarMsg');
  const codigo = normalizarCodigo(texto);
  if (!codigo){ aviso('#circBuscarMsg','bad','Escribí el código del pedido.'); return; }
  const turno = ++TURNO_BUSQUEDA;
  //  Los renglones de UN pedido: `pedir`, no `pedirTodo`. Un pedido que no se
  //  ve llega vacío, igual que uno sin nada entregado (la base recorta).
  const { data, error } = await pedir(sb.from('v_items_pedido').select('*')
    .eq('pedido', codigo).eq('estado', 'entregado').order('id'));
  if (turno !== TURNO_BUSQUEDA) return;
  BUSCADO = codigo;
  E_ENTREGADOS = error ? error.message : '';
  ENTREGADOS = error ? [] : (data || []);
  if (error)
    avisoHtml('#circBuscarMsg','bad', `No se pudo leer lo entregado del pedido ${esc(codigo)} ` +
      `(${esc(error.message)}). <b>No quiere decir que no tenga nada:</b> volvé a buscar.`);
  else if (!ENTREGADOS.length)
    aviso('#circBuscarMsg','warn', `El pedido ${codigo} no tiene nada en Entregado.`);
  pintarCircuito();
}

$('#circBuscarBtn').onclick = () => buscarEntregados($('#circBuscar').value);
$('#circBuscar').addEventListener('keydown', ev => { if (ev.key === 'Enter') buscarEntregados($('#circBuscar').value); });

//  «Volvió algo» desde Pedidos: aprieta la pestaña verdadera y deja el código
//  para cuando termine de cargar.
export function irADevolver(codigo: string){
  POR_BUSCAR = codigo;
  $('#tabCircuito').click();
}

//  Las filas de lo Entregado, ARRIBA de la tabla, con una fila que las separa.
const filasEntregados = () => !ENTREGADOS.length ? '' :
  `<tr data-devuelto-sep><td colspan="6"><b>Entregado del pedido ${esc(BUSCADO)} — ${
     ENTREGADOS.length} ${ENTREGADOS.length === 1 ? 'equipo' : 'equipos'}</b></td></tr>` +
  ENTREGADOS.map(i => filaItem(i, true)).join('') +
  `<tr data-devuelto-sep><td colspan="6" class="hint">Lo que hay para hacer</td></tr>`;

function filaItem(i, devuelto = false){
  return `
    <tr data-item="${i.id}"${devuelto ? ' data-devuelto' : ''}>
      <td class="mono">${esc(i.pedido)}</td>
      <td>${esc(i.cliente || '—')}</td>
      <td><span class="mono">${esc(i.producto)}</span> ${esc(i.descripcion)}${
        i.serie ? ` <span class="chip c-ok">${esc(i.serie)}</span>` : ''}</td>
      <td class="num">${i.cantidad}</td>
      <td><span class="chip ${devuelto ? 'c-ok' : 'c-pen'}">${esc(i.estado_nombre)}</span>${
        i.tipo_entrega && i.tipo_entrega !== 'retiro'
          ? ` <span class="hint">${esc(i.metodo_entrega || '')}</span>` : ''}</td>
      <td><div class="fila-acc">${accionesDe(i)}</div></td>
    </tr>`;
}

$('#filtroEstados').onchange = e => {
  FILTRO_ESTADO = el(e.target).value;
  pintarCircuito();
};

function accionesDe(item){
  // Dos filtros, los dos vienen de la base: por ROL (ya viene filtrada la
  // vista) y por RAMA, según cómo se entrega este pedido (0023). Un pedido sin
  // método de entrega no está ramificado: le aplica todo.
  //  ANTES QUE NADA: si la lista no se pudo leer no se sabe qué se puede hacer,
  //  que no es lo mismo que no poder hacer nada.
  if (ERROR_TRANS) return '<span class="hint">no se pudo leer qué se puede hacer</span>';
  //  LO QUE ESTÁ ARRIBA DE LA MOTO SE ENTREGA DESDE LA VUELTA (sesión 96).
  //  Un «Entregado» suelto acá no tiene dónde poner lo que se cobró, y la
  //  puerta de la plata lo frena (Steven, pedido 8). Quien carga entregas ve
  //  «Entregar», que lo lleva a Vueltas con la parada abierta. El código
  //  `en_transito` es el mismo que escriben `salir_vuelta` y `cargar_entrega`.
  const enMoto = item.estado === 'en_transito' && puede('entrega','registrar');
  const entregar = enMoto
    ? `<button class="b b-pri" data-entregar="${item.pedido_id}"
         title="Se carga en Vueltas → Mi vuelta, junto con lo que se cobró">Entregar</button>`
    : '';
  const vistos = new Set();
  const posibles = TRANSICIONES.filter(t =>
    t.desde === item.estado &&
    (!t.aplica_tipo || !item.tipo_entrega || t.aplica_tipo === item.tipo_entrega) &&
    !(enMoto && t.hasta === 'entregado') &&
    !vistos.has(t.hasta) && vistos.add(t.hasta));
  if (!posibles.length && !entregar) return '<span class="hint">nada para vos</span>';
  //  Segunda etapa (D181): el paso peligroso, separado y AL FINAL de la fila.
  posibles.sort((a, b) => Number(a.hasta === 'anulado') - Number(b.hasta === 'anulado'));
  return entregar + posibles.map(t =>
    `<button class="b ${t.hasta === 'anulado' ? 'b-peligro' : 'b-sec'}" data-mover="${item.id}"
             data-a="${esc(t.hasta)}"${t.es_deshacer ? ' title="Sólo mientras nadie más lo haya tocado"' : ''}
     >${t.es_deshacer ? '↩ Deshacer' : esc(t.hasta_nombre)}</button>`).join('');
}

function pintarCircuito(){
  //  Las tres respuestas de esta tabla: error · leyendo · datos.
  if (ERROR_ITEMS){
    $('#tblCircuito').innerHTML = filasEntregados() +
      '<tr><td colspan="6" class="vacio">No se pudo leer qué hay para hacer. ' +
      'Lo de antes no se muestra: no sabemos si sigue siendo así.</td></tr>';
    return;
  }
  if (!LEIDO_ITEMS){
    $('#tblCircuito').innerHTML = filasEntregados() +
      '<tr><td colspan="6" class="vacio">Leyendo qué hay para hacer…</td></tr>';
    return;
  }
  const f = CIRCUITO.filter(i => !FILTRO_ESTADO || i.estado_nombre === FILTRO_ESTADO);
  $('#tblCircuito').innerHTML = filasEntregados() + (f.map(i => filaItem(i)).join('') || (FILTRO_ESTADO && CIRCUITO.length
    //  LA SÉPTIMA RESPUESTA: nada coincide con el filtro. No es «no hay nada
    //  pendiente»: decirlo mal manda a alguien a casa con trabajo sin hacer.
    ? `<tr><td colspan="6" class="vacio">Ningún ítem está en «${esc(FILTRO_ESTADO)}».
         ${CIRCUITO.length === 1 ? 'Hay 1 pendiente en otro estado: sacá el filtro para verlo.'
           : `Hay ${CIRCUITO.length} pendientes en otros estados: sacá el filtro para verlos.`}</td></tr>`
    : '<tr><td colspan="6" class="vacio">No hay nada pendiente</td></tr>'));
}

function cerrarConfirmacion(){
  const f = document.getElementById('filaConfirmar');
  if (f) f.remove();
}

// Qué hace falta antes de entrar a un estado NO lo decide esta pantalla:
// sale de estados_item. Acá sólo se dibuja lo que la base ya exige.
async function abrirConfirmacion(item, t){
  cerrarConfirmacion();
  const fila = $(`#tblCircuito tr[data-item="${item.id}"]`);
  if (!fila) return;

  const pideMotivo = !!t.exige_motivo;
  const pideSerie  = !!t.exige_unidad && item.es_serializado;
  const revisar    = !!t.exige_revision;
  const grave      = t.hasta === 'anulado' || revisar;

  // Si hay plata de por medio, se muestra CUÁNTA antes de preguntar.
  let cobrado = null;
  if (revisar){
    const { data } = await rpcLee('cobrado_del_item', { p_item_id: item.id });
    cobrado = data;
  }

  //  Segunda etapa (D181): una frase, y el detalle plegado.
  const explico = revisar
    ? `<b>Esto ya se entregó.</b> Sacarlo NO devuelve la plata: después hay que anular el cobro.
       <details class="como"><summary>¿Cómo funciona?</summary><span class="hint">El
       equipo sigue afuera hasta que alguien lo marque Devuelto. Si hubo cobro, se
       anula en los cobros del pedido (al terminar te llevo): de mostrador sale de
       su caja; de la calle, de lo que la moto tiene que rendir o de la caja donde
       se rindió.</span></details>`
    : grave
    //  0057: anular lo que se separó o se empaquetó deja el producto en el
    //  depósito, apartado (no «fuera del depósito»).
    ? `El producto sale del pedido pero <b>sigue apartado</b>: no se puede vender
       hasta que alguien lo marque Devuelto, que es cuando vuelve a su lugar.`
    : ((t.hasta === 'empaquetado'
        ? `Segundo control antes de cerrar la caja. Pistoleá el equipo que estás
           empaquetando: tiene que ser <b>el mismo que separó el picker</b>.
           Si es otro, el sistema no te deja seguir.`
        : t.hasta === 'devuelto'
        ? `Pistoleá el equipo que estás recibiendo. Tiene que ser <b>el mismo que salió</b>:
           si es otro, el sistema lo rechaza.`
        : `Confirmá el cambio.`));

  //  LO QUE ESTE PANEL TIENE PARA DECIR VIVE EN ESTE PANEL: sus cinco avisos
  //  van a `#cfMsg` (nace y muere con la fila de confirmación) y NO a
  //  `#circMsg`, que es el cartel de la PANTALLA: un `innerHTML` ahí se llevaba
  //  la tarjeta del vale con el motivo ya tecleado.
  const tr = document.createElement('tr');
  tr.id = 'filaConfirmar';
  tr.innerHTML = `<td colspan="6">
    <div class="confirmar${grave ? ' grave' : ''}">
      <div class="conf-tit">${esc(t.hasta_nombre)} · ${esc(item.producto)} · pedido ${esc(item.pedido)}</div>
      <p class="conf-txt">${explico}</p>
      ${item.serie ? `<p class="conf-txt">Salió con la serie <b class="mono">${esc(item.serie)}</b>.</p>` : ''}
      ${revisar ? `<p class="conf-txt">Cobrado de este pedido:
          <b>${cobrado == null ? 'no se pudo leer'
             //  Cada cobro en SU moneda, como lo da `cobrado_del_item`. El
             //  `total` no se pinta: es la suma en la moneda base (pesos) de
             //  cobros en monedas distintas, y sin decir en cuál parecía USD
             //  (sesión 121, menor de la 116).
             : !Number(cobrado.pagos || 0) || !cobrado.detalle ? 'nada registrado'
             : esc(cobrado.detalle)}</b></p>
        <div class="chips-form"><label><input type="checkbox" id="cfRevisado">
          Entendí: la plata se devuelve aparte</label></div>
        ${t.hasta === 'anulado' ? '<p class="hint">Después del corte del día pide autorización.</p>' : ''}` : ''}
      <div class="grid ${pideMotivo && pideSerie ? 'g2' : ''}">
        ${pideMotivo ? `<label>Motivo <input id="cfMotivo"
            placeholder="Por qué se anula (queda registrado)" autocomplete="off"></label>` : ''}
        ${pideSerie ? `<label>Número de serie / IMEI <input id="cfSerie"
            placeholder="Escaneá el equipo" autocomplete="off"></label>` : ''}
      </div>
      <div class="fila-acc" style="margin-top:0.706rem">
        <button class="b b-sec" id="cfCancelar">Cancelar</button>
        <button class="b ${grave ? 'b-peligro' : 'b-pri'}" id="cfOk">${t.hasta === 'anulado'
          ? 'Sí, anular' : 'Sí, ' + esc(t.hasta_nombre.toLowerCase())}</button>
      </div>
      <div id="cfMsg"></div>
    </div></td>`;
  fila.after(tr);

  const primero = $('input', tr);
  if (primero) primero.focus();

  $('#cfCancelar', tr).onclick = cerrarConfirmacion;
  $('#cfOk', tr).onclick = async () => {
    const motivo = pideMotivo ? ($('#cfMotivo', tr).value.trim() || null) : null;
    if (pideMotivo && !motivo){ aviso('#cfMsg','bad','Escribí el motivo.'); return; }
    if (revisar && !$('#cfRevisado', tr).checked){
      aviso('#cfMsg','bad','Tildá la casilla del cobro antes de confirmar.'); return;
    }

    let unidad = null;
    if (pideSerie){
      const serie = $('#cfSerie', tr).value.trim();
      if (!serie){ aviso('#cfMsg','bad','Falta el número de serie.'); return; }
      //  LAS DOS RESPUESTAS NO SON LA MISMA. Hay tres salidas: la serie existe,
      //  NO existe, y **no se pudo preguntar**. Decir "no hay ninguna unidad con
      //  esa serie" a quien tiene el equipo en la mano es la afirmación más cara
      //  de esta pantalla (regla del 4/9): hay que mirar el `error`.
      const { data: u, error: eU } = await pedir(sb.from('unidades').select('id')
        .eq('serie', serie).eq('producto_id', item.producto_id).maybeSingle());
      if (eU){
        aviso('#cfMsg','bad', `No se pudo comprobar la serie ${serie} (${eU.message}). `
          + `No quiere decir que no exista: no se pudo preguntar. Volvé a intentarlo.`);
        return;
      }
      if (!u){
        aviso('#cfMsg','bad', `No hay ninguna unidad de ${item.producto} con la serie ${serie}.`);
        return;
      }
      unidad = u.id;
    }
    cerrarConfirmacion();
    await mover(item.id, t.hasta, motivo, unidad, revisar);
  };
  tr.addEventListener('keydown', ev => { if (ev.key === 'Escape') cerrarConfirmacion(); });
}

$('#tblCircuito').onclick = e => {
  const en = el(e.target).closest('[data-entregar]');
  if (en) return irAEntregar(Number(en.dataset.entregar));
  const b = el(e.target).closest('[data-mover]');
  if (!b) return;
  //  Una fila vieja (la lista se reemplazó mientras tanto) no tiene ítem: no
  //  se hace nada, y antes de mirar su estado.
  const item = itemDe(Number(b.dataset.mover));
  if (!item) return;
  const t = TRANSICIONES.find(x => x.desde === item.estado && x.hasta === b.dataset.a);
  if (!t) return;

  // Deshacer va derecho: es justamente para arreglar un clic de más.
  if (!t.es_deshacer &&
      (t.exige_motivo || t.exige_revision ||
       (t.exige_unidad && item.es_serializado) || t.hasta === 'anulado')){
    abrirConfirmacion(item, t);
    return;
  }
  mover(item.id, t.hasta);
};

//  LA SALIDA DEL MOSTRADOR
// ---------------------------------------------------------------------
//  Marcar Entregado desde acá cruza la misma puerta de la plata que la parada
//  del motoquero: `app.cambiar_estado_item` llama a `app.exigir_pago_del_item`
//  porque `entregado` tiene `exige_cobro`. La tarjeta de autorización es la de
//  Vueltas (vive en `aprobaciones.ts`); lo propio de acá es qué hacer cuando
//  respondan.
const COMO_SIGUE_EN_EL_MOSTRADOR =
  'Y si el pedido tiene más de un renglón sin entregar, puede que al marcar ' +
  'el siguiente te pida otra autorización por lo que falte. Cuando te ' +
  'respondan, volvés a apretar "Entregado". No le entregues nada al cliente ' +
  'hasta tener la respuesta.';

//  QUÉ SE OFRECIÓ Y SOBRE QUÉ. Lo que se ofrece caduca (D108), y acá también
//  si el ítem se movió por mano de otro: pedir un vale sobre un ítem ya
//  entregado es una solicitud real por algo que no existe.
let VALE_OFRECIDO: { item: number, estado: string } | null = null;

function caducarVale(){
  if (!VALE_OFRECIDO) return;
  const sigue = itemDe(VALE_OFRECIDO.item);
  if (sigue && sigue.estado === VALE_OFRECIDO.estado) return;
  //  Se va la tarjeta Y el rechazo que la trajo: hablaban de un estado que ya pasó.
  //  La del corte (0100, D219) va pegada AFUERA de `#circMsg`: se borra aparte.
  limpiar('#circMsg');
  document.getElementById('circCorte')?.remove();
  VALE_OFRECIDO = null;
}

async function mover(id, destino, motivo = null, unidad_id = null, confirmado = false){
  //  Lo que se ofreció se borra ANTES de decidir si se vuelve a ofrecer
  //  (regla 75); `#circMsg` es donde vive la tarjeta.
  limpiar('#circMsg');
  document.getElementById('circCorte')?.remove();
  VALE_OFRECIDO = null;
  //  Y el cartel SUELTO también: es el resultado de lo ANTERIOR, y un aviso
  //  viejo junto a uno nuevo se lee como si los dos fueran de ahora.
  limpiar('#circSueltoMsg');
  //  EL ÍTEM SE MIRA ANTES DEL `await` (regla 71): en la espera (D92)
  //  `CIRCUITO` se repinta entero y buscarlo después sería buscarlo en otra lista.
  const antes = itemDe(id);
  const devuelto = !!antes && ENTREGADOS.includes(antes);
  const { data, error } = await rpc('cambiar_estado_item', {
    p_item_id: id, p_estado: destino, p_motivo: motivo,
    p_unidad_id: unidad_id, p_confirmado: confirmado
  });
  if (error){
    aviso('#circMsg','bad', error.message);
    if (ofrecerVale({ contenedor: '#circMsg', prefijo: 'circVale',
                      pedidoId: antes?.pedido_id, mensaje: error.message,
                      comoSigue: COMO_SIGUE_EN_EL_MOSTRADOR,
                      cartelSuelto: '#circSueltoMsg' }))
      VALE_OFRECIDO = { item: Number(id), estado: antes.estado };
    //  0100 (D219) · anular después del corte: pedir la autorización ahí mismo.
    //  Caduca como la del vale (D108): si el ítem se mueve, se va.
    if (ofrecerPedirCorte({ despuesDe: '#circMsg', id: 'circCorte', prefijo: 'circCorte',
          mensaje: error.message, refTipo: 'pedido_item', refId: Number(id),
          comoSigue: 'Cuando te la den, volvé a pasar el ítem al mismo estado.' })
        && antes)
      VALE_OFRECIDO = { item: Number(id), estado: antes.estado };
    cargarCircuito(true);
    return;
  }
  const texto = data.mensaje + (data.pedido_cerrado ? ' El pedido quedó cerrado.' : '');
  //  D183: sacar de Entregado no devuelve la plata. Al terminar, el camino a
  //  los cobros de ese pedido, donde «Anular» la devuelve.
  if (devuelto){
    avisoHtml('#circMsg','ok', esc(texto) + ` <button class="b b-sec" id="circVerCobros">Ver los cobros del pedido</button>`);
    $('#circVerCobros').onclick = () => irACobros(Number(antes.pedido_id), antes.pedido);
  } else aviso('#circMsg','ok', texto);
  await cargarCircuito(true);
  //  La sección de lo Entregado se vuelve a leer: el ítem ya no está, y si
  //  queda otro, sigue.
  if (BUSCADO) await buscarEntregados(BUSCADO);
  cargarPedidos();
  cargarStock();
}
